/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { fileDistNameUniqueGet } from '../fn/file/file-dist-name-unique-get';
import { FileDistNameUniqueGet$Params } from '../fn/file/file-dist-name-unique-get';
import { fileItemIdGet } from '../fn/file/file-item-id-get';
import { FileItemIdGet$Params } from '../fn/file/file-item-id-get';
import { fileQueryPkGet } from '../fn/file/file-query-pk-get';
import { FileQueryPkGet$Params } from '../fn/file/file-query-pk-get';
import { fileViewsFileNameGet } from '../fn/file/file-views-file-name-get';
import { FileViewsFileNameGet$Params } from '../fn/file/file-views-file-name-get';

@Injectable({ providedIn: 'root' })
export class FileService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `fileDistNameUniqueGet()` */
  static readonly FileDistNameUniqueGetPath = '/file/dist/{nameUnique}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileDistNameUniqueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileDistNameUniqueGet$Response(params: FileDistNameUniqueGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return fileDistNameUniqueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileDistNameUniqueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileDistNameUniqueGet(params: FileDistNameUniqueGet$Params, context?: HttpContext): Observable<void> {
    return this.fileDistNameUniqueGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `fileQueryPkGet()` */
  static readonly FileQueryPkGetPath = '/file/query/{pk}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileQueryPkGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileQueryPkGet$Response(params: FileQueryPkGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return fileQueryPkGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileQueryPkGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileQueryPkGet(params: FileQueryPkGet$Params, context?: HttpContext): Observable<void> {
    return this.fileQueryPkGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `fileItemIdGet()` */
  static readonly FileItemIdGetPath = '/file/item/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileItemIdGet$Response(params: FileItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return fileItemIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileItemIdGet(params: FileItemIdGet$Params, context?: HttpContext): Observable<void> {
    return this.fileItemIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `fileViewsFileNameGet()` */
  static readonly FileViewsFileNameGetPath = '/file/views/{fileName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileViewsFileNameGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileViewsFileNameGet$Response(params: FileViewsFileNameGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return fileViewsFileNameGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileViewsFileNameGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileViewsFileNameGet(params: FileViewsFileNameGet$Params, context?: HttpContext): Observable<void> {
    return this.fileViewsFileNameGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
